import React, { Component } from 'react';
import commonHelpers from "../../libs/helpers/commonHelpers";
import { Table, FormControl, OverlayTrigger, Popover, Button } from 'react-bootstrap';
import { Navbar, Nav, NavItem, NavDropdown, MenuItem } from 'react-bootstrap';
import httpHelper from "../../libs/helpers/httpHelpers";
const loggedUser = commonHelpers.getLoggedUser();

export default class HeaderComponent extends Component {

  logout = ()=> {

    const apiUrl = `user/logout`;
    const _this = this;
    const headers = {Authorization: `bearer ${loggedUser.authentication}`};

    httpHelper.get(apiUrl, headers).then(function (response) {
      if(response.data.command === "DO_LOGOUT"){
        commonHelpers.removeLoggedUser();
        window.location.reload();

      }else{
        _this.setState({
          show: true,
          message: 'Unable to logout',
          type: 'error'
        });
      }
    }).catch(function (error) {
      _this.setState({
        show: true,
        message: 'Unable to logout',
        type: 'error'
      });
    });

  }

  render() {
    const loggedUserObj = loggedUser ? loggedUser.user : undefined;
    const userName = loggedUserObj ? `${loggedUserObj.first_name.substring(0,1)}. ${loggedUserObj.last_name}` : '';

    const popover = (
      <Popover id="popover-trigger-click-root-close" className="custom-table-action-popover">
        <div className="popover-item"><a > view profile</a></div>
        <div className="popover-item"><a >logout</a></div>
      </Popover>
    );
    return (
      <header className="landing-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="branding clearfix"><a href="/"><img src={ require("../../assets/images/landing-logo.png") } alt="Vocalize" className="img-logo" /></a></div>
              {
                  loggedUser && loggedUser.user ?
                    <div className="header-actions logged-in clearfix">
                      <Navbar staticTop={true} fluid={true}>
                        <Navbar.Collapse>
                        <Nav pullRight >
                          <NavDropdown eventKey={1} title={userName} id="basic-nav-dropdown" className="user-menu-dropdown">
                            {
                              loggedUser.user.email_verified &&
                              <MenuItem eventKey={1.1} onClick={() => {this.props.history.push('/profile')}}>View Profile</MenuItem>
                            }
                            <MenuItem eventKey={1.2} onClick={() => {this.logout()}}>Logout</MenuItem>
                          </NavDropdown>
                        </Nav>
                        </Navbar.Collapse>
                      </Navbar>
                    </div> :
                    <div className="header-actions button-wrapper clearfix">
                      <a href="/signup" className="btn-register">Register</a>
                      <a href="/login" className="btn-login">Login</a>
                    </div>
                }
              <Navbar collapseOnSelect className="mobile-nav">
                <Navbar.Header>
                  <Navbar.Toggle pullRight/>
                </Navbar.Header>
                <Navbar.Collapse>
                  {
                    loggedUser && loggedUser.user ?
                      <Nav>
                        {
                          loggedUser.user.email_verified &&
                          <NavItem eventKey={2} href="/profile">
                            View Profile
                          </NavItem>
                        }
                        <NavItem eventKey={2} onClick={() => {this.logout()}}>
                          Logout
                        </NavItem>
                      </Nav> :
                      <Nav>
                        <NavItem eventKey={1} href="/signup">
                          Register
                        </NavItem>
                        <NavItem eventKey={2} href="/login">
                          Login
                        </NavItem>
                      </Nav>
                  }

                </Navbar.Collapse>
              </Navbar>
            </div>
          </div>
        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/landing/HeaderComponent.js